import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <Section data-id="element-93">
      {/* Product Mockup */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="mb-10 rounded-2xl overflow-hidden shadow-2xl shadow-warm-brown/10" data-id="element-94">
        <img src="https://cdn.magicpatterns.com/uploads/aFnz8UHJWsG81iXcyJnZZT/heylloyd-image-1771047228665.png" alt="Calma Espiritual (7 días) — Mockup del producto digital" className="w-full h-auto" data-id="element-95" />
      </motion.div>

      <div className="relative bg-sage-light/20 border border-sage/20 p-8 md:p-12 rounded-lg text-center overflow-hidden" data-id="element-96">
        <h2 className="text-3xl md:text-4xl font-serif mb-6 text-warm-brown relative z-10" data-id="element-97">
          Calma Espiritual (7 días)
        </h2>

        <p className="text-xl leading-relaxed mb-8 text-warm-brown/90 relative z-10" data-id="element-98">
          Un PDF premium + cuaderno imprimible diseñado para una sola cosa: que
          puedas volver a vos en{' '}
          <strong className="text-terracotta" data-id="element-99">14 minutos por día</strong>, sin
          mística rara, sin culpas, sin presión.
        </p>

        <div className="inline-block border-t border-b border-gold/30 py-4 px-8 relative z-10" data-id="element-100">
          <p className="font-serif italic text-lg text-warm-brown" data-id="element-101">
            No es un libro para leer y "entender". Es un sistema para hacer.
          </p>
        </div>

        <div className="mt-8 relative z-10" data-id="element-102">
          <span className="text-warm-brown/40 line-through text-base mr-2" data-id="element-103">
            $14.900
          </span>
          <span className="text-2xl font-serif font-bold text-terracotta" data-id="element-104">
            $8.900 ARS
          </span>
        </div>
      </div>
    </Section>;
}